import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { AurFormControl } from '../../models/form-control.model';
import { ErrorMessageModel } from '../../models/error-message.model';

@Component({
    selector: 'aur-date',
    template: `<mat-form-field [formGroup]="formGroup" fxFlex>
    <span *ngIf="control.prefix" matPrefix>{{ control.prefix }}</span>

    <input matInput
        [matDatepicker]="datepicker"
        [formControlName]="control.name"
        [placeholder]="control.placeholder"
        [required]="control.isRequired"
        [max]="control.max"
        [min]="control.min"
        disabled="{{ control.isReadonly }}" />

    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
    <mat-datepicker #datepicker></mat-datepicker>

    <span *ngIf="control.suffix" matSuffix>{{ control.suffix }}</span>

    <mat-error>
        {{ getErrorMessage() }}
    </mat-error>
</mat-form-field>`
})
export class DateComponent {

    @Input() formGroup: FormGroup;
    @Input() control: AurFormControl;

    getErrorMessage(): string {
        return (<AurFormControl>this.formGroup.controls[this.control.name]).errorMessages
            .filter((errorMessage: ErrorMessageModel) => this.formGroup.controls[this.control.name].hasError(errorMessage.type))
            .map((errorMessage: ErrorMessageModel) => errorMessage.text)[0];
    }
}
